import $ from 'jquery';
import AirDatepicker from 'air-datepicker';
import localEn from 'air-datepicker/locale/en';
import { trapFocus, releaseFocus } from '../../common/js/modalA11y';

const exitPopUp = {
    variables: {
        incomeLabels: $(".income__label"),
        popupContainer: $(".popup__container"),
        formContentContainer: $(".exitform__content"),
        formResponseContainer: $(".form__response"),
        closePopUpBtn: $(".close__btn"),
        submitFormBtn: $(".submit__btn"),
        inputFieldError: $(".exitform-empty-error"),
        formResponseNameSpan: $('.form__input-name'),
        checkTC: $(".privacy__input"),
        imageContainer: $(".form__background-image"),
        nameInput: $(".form__input.full_name"),
        phoneInput: $(".form__input.mob_num"),
        emailInput: $(".form__input.email"),
        dobInput: $(".form__input.dob"),
        websiteSectionNameInput: $(".form__input.exitPopupWebsiteSectionName"),
        productNameInput: $(".form__input.exitPopupProductName"),
        productCategoryInput: $(".form__input.exitPopupProductCategory"),
        inputs: $(".input__container .form__input"),
    },
    state: {
        selectedIncome: undefined,
        responseLeadId: undefined,
    },
    methods: {
        convertDateFormat: function(dateString) {
            if (!dateString) return "";
            const [year, month, day] = dateString.split("-");
            const monthNames = [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];
            return `${day}-${monthNames[parseInt(month, 10) - 1]}-${year}`;
        },
        dataLayerObj: function(el, e, tabText, responseLeadId) {
            const name = exitPopUp.variables.nameInput.val().trim();
            const mobileNumber = exitPopUp.variables.phoneInput.val().trim();
            const email = exitPopUp.variables.emailInput.val().trim();
            const dob = exitPopUp.methods.convertDateFormat(exitPopUp.variables.dobInput.val().trim());
            const annualIncome = exitPopUp.state.selectedIncome;
            var obj = {
                'articleName': "",
                'blogCategory': "",
                'blogPageCategory': "",
                'buttonText': el ? el : "",
                'pageSection': e ? e : "Form_".concat(tabText),
                'pageType': $("meta[name='template']").attr('content') == 'chli-base-page-template'
                    ? window.location.href.includes("blog")
                        ? "Blogs"
                        : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com"
                            ? "Home"
                            : "Other Pages"
                    : "Blog Details Page",
                'planOption': "",
                'productCategory': "",
                'productName': "",
                'question': "",
                'source': "",
                'leadForm': "",
                'name': name,
                'email': email,
                'dob': dob,
                'countryCode': "+91",
                'mobileNumber': mobileNumber,
                'pincode': "",
                'city': "",
                'leadId': responseLeadId ? responseLeadId : "",
                'searchTerm': "",
                'videoTitle': "",
                'annualIncome': annualIncome,
                'bannerName': "",
            };
            return obj;
        },
        getQueryStringValue: function(key) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.has(key)) {
                return urlParams.get(key);
            } else {
                return null;
            }
        },
        closePopUp: function() {
            let formValid = false;
            if (exitPopUp.variables.nameInput.val().trim() !== "" && exitPopUp.variables.phoneInput.val().trim() !== "" && exitPopUp.variables.emailInput.val().trim() !== "" && exitPopUp.variables.dobInput.val().trim() !== "" && exitPopUp.state.selectedIncome) {
                formValid = true;
            }
            if (!formValid) {
                exitPopUp.variables.nameInput.val("");
                exitPopUp.variables.phoneInput.val("");
                exitPopUp.variables.emailInput.val("");
                exitPopUp.variables.dobInput.val("");
                exitPopUp.state.selectedIncome = "";
                if(exitPopUp.variables.incomeLabels.hasClass("active"))
                  exitPopUp.variables.incomeLabels.removeClass("active");
            }
            const obj = exitPopUp.methods.dataLayerObj("ClosePopUp", null, "ClosePopup", exitPopUp.state.responseLeadId);
            exitPopUp.variables.popupContainer.removeClass("show-popup").addClass("hide-popup");
            $(".custom-container-margin").removeClass("custom-container-margin");
            $(".basepage-overflow-hidden").removeClass("basepage-overflow-hidden");
            $(".exit-popup-overflow").removeClass("exit-popup-overflow");
            releaseFocus();
            createDataLayer("buttonClick", obj);
        },
        showError: function(errorContainer, errorType, field) {
            let errorMsgSpan = errorContainer.find('.exitform-empty-error');
            let invalidNameSpan = errorContainer.find('.exitform-invalid-error');
            const emptyMsg = errorMsgSpan.text();
            const invalidMsg = invalidNameSpan.text();
            errorMsgSpan.addClass('hide__empty-error');
            invalidNameSpan.addClass('hide__empty-error');
            if (errorType === 'empty') {
                errorMsgSpan.removeClass('hide__empty-error').text(emptyMsg);
            } else if (errorType === 'invalid') {
                invalidNameSpan.removeClass('hide__empty-error').text(invalidMsg);
            }
        },
        hideError: function(errorContainer) {
            errorContainer.find('.exitform-empty-error').addClass('hide__empty-error');
            errorContainer.find('.exitform-invalid-error').addClass('hide__empty-error');
        },
        submitForm: function(e) {
            e.preventDefault();
            let formValid = true;
            if (exitPopUp.variables.nameInput.val().trim() === "") {
                formValid = false;
                exitPopUp.methods.showError(exitPopUp.variables.nameInput.parent(), 'empty', 'full_name');
            } else if (exitPopUp.variables.nameInput.val().trim().length < 3) {
                formValid = false;
                exitPopUp.methods.showError(exitPopUp.variables.nameInput.parent(), 'invalid', 'full_name');
            } else {
                exitPopUp.methods.hideError(exitPopUp.variables.nameInput.parent());
            }

            const mobileRegex = /^[6-9]\d{9}$/;
            if (exitPopUp.variables.phoneInput.val().trim() === "") {
                formValid = false;
                exitPopUp.methods.showError(exitPopUp.variables.phoneInput.parent(), 'empty', 'mobile');
            } else if (!mobileRegex.test(exitPopUp.variables.phoneInput.val().trim())) {
                formValid = false;
                exitPopUp.methods.showError(exitPopUp.variables.phoneInput.parent(), 'invalid', 'mobile');
            } else {
                exitPopUp.methods.hideError(exitPopUp.variables.phoneInput.parent());
            }

            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (exitPopUp.variables.emailInput.val().trim() === "") {
                formValid = false;
                exitPopUp.methods.showError(exitPopUp.variables.emailInput.parent(), 'empty', 'email');
            } else if (!emailRegex.test(exitPopUp.variables.emailInput.val().trim())) {
                formValid = false;
                exitPopUp.methods.showError(exitPopUp.variables.emailInput.parent(), 'invalid', 'email');
            } else {
                exitPopUp.methods.hideError(exitPopUp.variables.emailInput.parent());
            }

            if (exitPopUp.variables.dobInput.val().trim() !== "") {
                const dateInInput = exitPopUp.variables.dobInput.val().trim();
                const convertedDate = exitPopUp.methods.convertDateFormat(dateInInput);
                const dobRegex = /^(0[1-9]|[12][0-9]|3[01])-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-\d{4}$/;
                const enteredDate = new Date(dateInInput);
                const today = new Date();
                const yearsDifference = today.getFullYear() - enteredDate.getFullYear();
                const isBeforeBirthday = (
                   today.getMonth() < enteredDate.getMonth() ||
                  (today.getMonth() === enteredDate.getMonth() && today.getDate() < enteredDate.getDate())
                );
               const age = isBeforeBirthday ? yearsDifference - 1 : yearsDifference;
                if (enteredDate > today || age < 18) {
                    formValid = false;
                    exitPopUp.methods.showError(exitPopUp.variables.dobInput.parent(), 'invalid', 'dob');
                } else if (!dobRegex.test(convertedDate)) {
                    formValid = false;
                    exitPopUp.methods.showError(exitPopUp.variables.dobInput.parent(), 'empty', 'dob');
                } else {
                    exitPopUp.methods.hideError(exitPopUp.variables.dobInput.parent());
                }
            } else {
                formValid = false;
                exitPopUp.methods.showError(exitPopUp.variables.dobInput.parent(), 'empty', 'dob');
            }

            const incomeRadios = $(".income__input");
            const incomeErrorContainer = $(".exitform__group.income .exitform-empty-error");
            const incomeError = $('.income .exitform-empty-error');
            if (!incomeRadios.is(":checked")) {
                formValid = false;
                incomeErrorContainer.text(incomeError.text().trim()).removeClass("hide__empty-error");
            } else {
                incomeErrorContainer.addClass("hide__empty-error");
            }

            const checkBoxContainer = $(".checkbox__container .exitform-empty-error");
            const checkboxError = $(".checkbox__container .exitform-empty-error");
            if (!exitPopUp.variables.checkTC.is(":checked")) {
                formValid = false;
                checkBoxContainer.text(checkboxError.text()).removeClass("hide__empty-error");
            } else {
                checkBoxContainer.addClass("hide__empty-error");
            }
            if (formValid) {
                const loader = $('.response__loader');
                loader.css('display', 'flex');
                const json = {
                    fullName: exitPopUp.variables.nameInput.val().trim(),
                    mobileNumber: exitPopUp.variables.phoneInput.val().trim(),
                    email: exitPopUp.variables.emailInput.val().trim(),
                    dob: exitPopUp.methods.convertDateFormat(exitPopUp.variables.dobInput.val().trim()),
                    annualIncome: exitPopUp.state.selectedIncome,
                    Website_Section_Name: exitPopUp.variables.websiteSectionNameInput && exitPopUp.variables.websiteSectionNameInput.val()
                                           ? exitPopUp.variables.websiteSectionNameInput.val().trim() : '',
                    productName: exitPopUp.variables.productNameInput && exitPopUp.variables.productNameInput.val()
                                           ? exitPopUp.variables.productNameInput.val().trim() : '',
                    productCategory: exitPopUp.variables.productCategoryInput && exitPopUp.variables.productCategoryInput.val()
                                           ? exitPopUp.variables.productCategoryInput.val().trim() : '',
                    gaId: getClientId(),
                };
                let utm_medium = exitPopUp.methods.getQueryStringValue('utm_medium');
                let utm_source = exitPopUp.methods.getQueryStringValue('utm_source');
                let utm_campaign = exitPopUp.methods.getQueryStringValue('utm_campaign');
                let utm_content = exitPopUp.methods.getQueryStringValue('utm_content');
                let utm_term = exitPopUp.methods.getQueryStringValue('utm_term');
                let utm_cohort = exitPopUp.methods.getQueryStringValue('utm_cohort');
                if (utm_medium != null) {
                    json["utmMedium"] = utm_medium;
                }
                if (utm_source != null) {
                    json["utmSource"] = utm_source;
                } else {
                    json["utmSource"] = "Organic";
                }
                if (utm_campaign != null) {
                    json["utmCampaign"] = utm_campaign;
                }
                if (utm_content != null) {
                    json["utmContent"] = utm_content;
                }
                if (utm_term != null) {
                    json["utmTerm"] = utm_term;
                }
                if (utm_cohort != null) {
                    json["utmCohort"] = utm_cohort;
                }
                const buttonText = exitPopUp.variables.submitFormBtn.text().trim();
                const url = "/bin/chli/genericForm?servletID=digital";
                $.ajax({
                    type: "POST",
                    url: url,
                    data: JSON.stringify(json),
                    contentType: "application/json",
                    dataType: "json",
                }).done((response) => {
                    loader.css('display', 'none');
                    const submittedName = exitPopUp.variables.nameInput ? exitPopUp.variables.nameInput.val().trim() : "";
                    exitPopUp.variables.imageContainer.addClass("image__display-none");
                    if (submittedName) {
                        exitPopUp.variables.formResponseNameSpan.text(submittedName);
                    }
                    exitPopUp.variables.formContentContainer.removeClass("show__form-content").addClass("hide__form-content");
                    exitPopUp.variables.formResponseContainer.removeClass("hide__form-response").addClass("show__form-response");
                    exitPopUp.state.responseLeadId = response.leadId;
                    const obj1 = exitPopUp.methods.dataLayerObj(buttonText, null, "LeadSubmitted", exitPopUp.state.responseLeadId);
                    createDataLayer("LeadSubmitted", obj1);
                    const obj2 = exitPopUp.methods.dataLayerObj(buttonText, null, "ExitPopUpClose_ThankYou", exitPopUp.state.responseLeadId);
                    createDataLayer("ExitPopUpClose_ThankYou", obj2);
                }).catch((error) => {
                    console.log(error);
                });
            }
        },
        bindEvents: function() {
            exitPopUp.variables.incomeLabels.on("click", function() {
                exitPopUp.variables.incomeLabels.removeClass("active");
                $(this).addClass("active");
                exitPopUp.state.selectedIncome = $(this).find("input").val();
            });

            exitPopUp.variables.checkTC.on("click", function() {
                if ($(this).is(":checked")) {
                    $(this).attr("checked", "checked");
                } else {
                    $(this).removeAttr("checked");
                }
            });

            exitPopUp.variables.nameInput.on('input', function() {
                $(this).val($(this).val().replace(/[^a-zA-Z\s]/g, ''));
            });
            exitPopUp.variables.phoneInput.on('input', function() {
                $(this).val($(this).val().replace(/[^0-9]/g, '').slice(0, 10));
            });

            exitPopUp.variables.inputs.each(function() {
                const input = $(this);
                const labelContainer = input.prev();
                input.on("focus", function() {
                    if (input.attr("placeholder")) {
                        labelContainer.text(input.attr("placeholder"));
                        labelContainer.css("visibility", "visible");
                        input.attr("placeholder", "");
                    }
                });
                input.on("blur", function() {
                    if (input.val() === "") {
                        input.attr("placeholder", labelContainer.text());
                        labelContainer.text("");
                        labelContainer.css("visibility", "hidden");
                    }
                });
            });

            exitPopUp.variables.closePopUpBtn.on("click", function() {
                exitPopUp.methods.closePopUp();
            });

            // Escape key to close popup (WCAG 2.1.2 — No Keyboard Trap)
            $(document).on("keydown", function(e) {
                if (e.key === "Escape" && exitPopUp.variables.popupContainer.hasClass("show-popup")) {
                    e.preventDefault();
                    exitPopUp.methods.closePopUp();
                }
            });

            // Trap focus when popup becomes visible
            var popupObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.attributeName === "class") {
                        var $target = $(mutation.target);
                        if ($target.hasClass("show-popup")) {
                            trapFocus($target);
                        }
                    }
                });
            });
            if (exitPopUp.variables.popupContainer.length) {
                popupObserver.observe(exitPopUp.variables.popupContainer[0], { attributes: true });
            }

            exitPopUp.variables.submitFormBtn.on("click", function(e) {
                exitPopUp.methods.submitForm(e);
            });
        },
        init: function() {
            exitPopUp.variables.formContentContainer.addClass("show__form-content");
            exitPopUp.variables.formResponseContainer.addClass("hide__form-response");
            exitPopUp.variables.popupContainer.addClass("hide-popup");
            exitPopUp.variables.inputFieldError.addClass("hide__empty-error");
            exitPopUp.methods.bindEvents();

            const today = new Date();
            const maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const initialDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

            new AirDatepicker('.form__input.dob', {
                dateFormat: 'yyyy-MM-dd',
                isMobile: window.matchMedia('(max-width: 768px)').matches,
                autoClose: true,
                locale: localEn,
                maxDate: maxDate,
                startDate: initialDate,
                onSelect({ date }) {
                    if (date) {
                        const selectedDate = new Date(date);
                        const yearsDifference = today.getFullYear() - selectedDate.getFullYear();
                        const isBeforeBirthday = (
                            today.getMonth() < selectedDate.getMonth() ||
                            (today.getMonth() === selectedDate.getMonth() && today.getDate() < selectedDate.getDate())
                        );
                        const age = isBeforeBirthday ? yearsDifference - 1 : yearsDifference;

                        if(age < 18){
                            exitPopUp.methods.showError(exitPopUp.variables.dobInput.parent(), 'invalid', 'dob');
                        }else{
                            exitPopUp.methods.hideError(exitPopUp.variables.dobInput.parent());
                        }
                    }
                }
            });
        }
    }
};

$(document).ready(function() {
    exitPopUp.methods.init();
});